import { useState, useCallback } from "react";
import type { VisibilityState } from "@tanstack/react-table";

const LS_KEY = "chargersColumnConfig_v1";

const DEFAULT_VISIBILITY: VisibilityState = {
  status: true,
  name: true,
  product: true,
  voltage: true,
  current: true,
  session_energy: true,
  location: true,
  power_factor: false,
  protocol_version: false,
  unit_id_col: false,
};

function loadFromStorage(): VisibilityState {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (raw) return JSON.parse(raw) as VisibilityState;
  } catch {}
  return { ...DEFAULT_VISIBILITY };
}

export function useColumnConfig() {
  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(loadFromStorage);

  const setVisibility = useCallback((updater: VisibilityState | ((prev: VisibilityState) => VisibilityState)) => {
    setColumnVisibility((prev) => {
      const next = typeof updater === "function" ? updater(prev) : updater;
      localStorage.setItem(LS_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const resetToDefaults = useCallback(() => {
    const defaults = { ...DEFAULT_VISIBILITY };
    localStorage.setItem(LS_KEY, JSON.stringify(defaults));
    setColumnVisibility(defaults);
  }, []);

  return { columnVisibility, setColumnVisibility: setVisibility, resetToDefaults };
}
